/**
 * appConstants.js defines constants for site usage
 */
export const USAGE_REPORTING_TRACK_ENTITY = '_trackEntity'
export const USAGE_REPORTING_TRACK_ENTITY_DATA_CATEGORY_CUSIP = 'cusip'
export const USAGE_REPORTING_TRACK_PAGE = '_trackPageView'
export const USAGE_REPORTING_TRACK_PAGE_DATA_PAGE = 'adrAppView'

export const KEY_LOCAL_STORAGE_SHOW_DEBUG_INFO = 'show-debug-info'
